// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '395694503906-vhm8d1km1c4rq0oat4fc44uttaila6i0.apps.googleusercontent.com';

// Redirect URI для OAuth callback
// В разработке использует переменную окружения, в продакшене - текущий домен
export const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI || 
  `${window.location.origin}/auth/google/callback`;

// Google OAuth endpoints
export const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
export const GOOGLE_TOKEN_URL = 'https://oauth2.googleapis.com/token';

// Scopes для OpenID Connect
export const GOOGLE_SCOPES = [
  'openid',
  'email',
  'profile'
].join(' ');

/**
 * Генерирует URL для авторизации через Google.
 * accountType ('candidate' | 'employer') is round-tripped through Google's
 * `state` param so the callback screen knows which flow to continue.
 */
export function getGoogleAuthUrl(accountType = 'candidate') {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: GOOGLE_REDIRECT_URI,
    response_type: 'code',
    scope: GOOGLE_SCOPES,
    access_type: 'offline',
    prompt: 'consent',
    state: accountType === 'employer' ? 'employer' : 'candidate',
  });

  return `${GOOGLE_AUTH_URL}?${params.toString()}`;
}
